import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import HomeSlider from "../../components/HomeSlider";
import HomeIntroSection from "../../components/HomeIntro";
import Program from "../../components/Program";
import SEO from "../../components/SEO";

const HomePage = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const hash = window.location.hash;
    const pathname = window.location.pathname;

    if (pathname === "/program" || hash === "#program-section") {
      const el = document.getElementById("program-section");
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  return (
    <div>
      <SEO
        title={window.location.pathname === "/program" ? t("seo.program.title") : undefined}
        description={window.location.pathname === "/program" ? t("seo.program.description") : undefined}
        keywords={window.location.pathname === "/program" ? t("seo.program.keywords") : undefined}
      />
      <HomeSlider />
      <HomeIntroSection />
      <Program />
    </div>
  );
};

export default HomePage;